import { Check } from 'lucide-react';

import type { EventTheme } from '@/types/wizard';
import styles from './ThemeCard.module.css';

interface Props {
  theme: EventTheme;
  isSelected: boolean;
  onClick: () => void;
}

export const ThemeCard = ({ theme, isSelected, onClick }: Props) => {
  return (
    <div className={`${styles.card} ${isSelected ? styles.selected : ''}`} onClick={onClick}>
      <div
        className={styles.colorBanner}
        style={{
          background: `linear-gradient(135deg, ${theme.color_suggestion.primary}, ${theme.color_suggestion.accent})`,
        }}
      >
        {isSelected && (
          <span className={styles.checkBadge}>
            <Check size={14} strokeWidth={3} color={theme.color_suggestion.primary} />
          </span>
        )}
      </div>
      <div className={styles.info}>
        <h3 className={styles.name}>{theme.name}</h3>
        <p className={styles.description}>{theme.description}</p>
        <div className={styles.tags}>
          {theme.tags.slice(0, 3).map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
          {theme.tags.length > 3 && <span className={styles.more}>+{theme.tags.length - 3}</span>}
        </div>
      </div>
    </div>
  );
};
